/*************************************************************************
*
*  Copyright 2020 Adobe
*  All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/

// Last resort... browser checks for issues we cannot identify with feature detection

export const isEdge = () => /Edge/.test(navigator.userAgent); // old Edge, not Edgium
export const isIE = () => !!document.documentMode;
export const isMobileDevice = () =>
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

// Function to detect Safari 18
export const isSafari18 = () => {
    const userAgent = navigator.userAgent;
    const isSafari = /Safari/.test(userAgent) && !/(Chrome|Chromium|Edg)/.test(userAgent);
    const versionMatch = userAgent.match(/Version\/(\d+)/);

    if (isSafari && versionMatch) {
        const version = parseInt(versionMatch[1], 10);
        return version === 18; // Return true if it’s Safari 18
    }

    return false;
};

// Function to detect iOS 18
export const isIOS18 = () => {
    const userAgent = navigator.userAgent;
    const isIOS = /iPhone|iPad|iPod/.test(userAgent); // Check if it’s an iOS device
    const iOSVersionMatch = userAgent.match(/OS (\d+)_/); // Match the iOS version in userAgent (e.g., OS 18_0)

    if (isIOS && iOSVersionMatch) {
        const iOSVersion = parseInt(iOSVersionMatch[1], 10);
        return iOSVersion === 18; // Return true if it’s iOS 18
    }

    return false;
};
